import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "@mui/material";
import {Controller} from "react-hook-form";
import React from "react";
import _ from "lodash";

export default function Choices(
  {
    errors = {},
    control,
    name,
    variant = "standard",
    fullWidth = true,
    label,
    items = {},
    margin,
    onBlur,
    helperText,
    ...props
  },
) {
  const error = _.get(errors, name);

  return (
    <FormControl
      variant={variant}
      fullWidth={fullWidth}
      margin={margin}
      error={!!error}
      onBlur={onBlur}
    >
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Controller
        name={name}
        control={control}
        defaultValue=""
        render={({field}) => (
          <Select
            label={label}
            inputProps={{
              id: name,
            }}
            {...props}
            {...field}
            value={field?.value === null ? 'null' : field?.value}
          >
            {Object.entries(items)
              .map(([value, key]) => (
                <MenuItem value={value} key={value}>{key}</MenuItem>
              ))}
          </Select>
        )}
      />
      {error ? <FormHelperText>{error.message}</FormHelperText> : null}
      {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
    </FormControl>
  );
}
